import moment from 'moment';
import { SnackbarProvider, useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SignatureCanvas from 'react-signature-canvas';
import { DotLoaderOverlay } from 'react-spinner-overlay';

//MODAL 
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';


/** Servicios */
import aprobadorService from '../services/aprobador.service';
import causalService from '../services/causal.service';
import correoService from '../services/correo.service';
import emailService from '../services/email.service';
import personaService from '../services/persona.service';
import causalesService from '../services/causales.service';

/** MUI NUEVO */
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { IconButton, TextField } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import Collapse from '@mui/material/Collapse';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';

import proyectoService from '../services/proyecto.service';
import usuarioService from '../services/usuario.service';

const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const FiniquitoRRLL = () => {
    const { id_causal } = useParams();
    const [causal, setCausal] = useState('');
    const [persona, setPersona] = useState('');
    const [expanded, setExpanded] = React.useState(true);
    const [sigPad, setSigPad] = useState({});
    const { enqueueSnackbar } = useSnackbar();
    const [correos, setCorreos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = React.useState(false);
    let navigate = useNavigate();
    const [rechazo, setRechazo] = useState(false);
    const [motivoRechazo, setMotivoRechazo] = useState('');
    const [modificarCausal, setModificarCausal] = useState('');
    const [motivoModificarCausal, setMotivoModificarCausal] = useState('');
    const [causalmaestro, setcausalmaestro] = useState([])
    const [value, setValue] = React.useState('');
    const [error, setError] = React.useState(false);
    const [modalcausales, setmodalcausales] = useState(false);
    const [helperText, setHelperText] = useState('');
    const [isSwitchOn, setIsSwitchOn] = useState('');
    


    useEffect(() => {
        retreiveCausal();
        retreiveCorreos();
        retrieveCausales();
    }, []);

    async function retrieveCausales() {
        try {
            let mc = await causalesService.getAll();
            console.log("Causales", mc.data);

            setcausalmaestro(mc.data)

        }
        catch (err) {
            console.error(err);
        }
    }

    async function retreiveCausal() {
        try {
            let c = await causalService.getId(id_causal);
            setCausal(c.data);
            setPersona(c.data.persona);
            if (c.data.persona.estado_desv !== "En Jefe de RRLL") {
                setOpen(true);
            }
        } catch (err) {
            console.log(err);
        }
    }
    async function updateCausal(id_causal, updatedData) {
        try {
            // Llamada al servicio para actualizar la causal
            const response = await causalService.update(id_causal, updatedData);
            console.log("Causal actualizada:", response.data);

            // Opcional: Actualizar el estado local con los datos actualizados
            setCausal(response.data);

            // Mostrar notificación de éxito
            enqueueSnackbar("Causal actualizada correctamente!", { variant: "success" });
        } catch (err) {
            console.error("Error al actualizar la causal:", err);

            // Mostrar notificación de error
            enqueueSnackbar("Error al actualizar la causal!", { variant: "error" });
        }
    }


    const handleRadioChange = (event) => {
        setValue(event.target.value);
        setHelperText(' ');
        setError(false);
    };


    const handleSubmitModificarCausal = async (event) => {
        event.preventDefault();
    
        try {
            // Obtener los datos de la causal seleccionada
            const mc = await causalesService.getId(value);
            console.log("Causal seleccionada:", mc);
    
            // Preparar los datos para la actualización
            const updateData = {
                nombre: mc.data.nombre,
                descripcion: mc.data.descripcion,
            };
            console.log(causal.id)
            // Llamar a la función updateCausal para actualizar en la base de datos
            await updateCausal(id_causal, updateData);
    
            // Mostrar un mensaje de éxito en el helperText
            setHelperText(`Modificaste la causal a ${mc.data.nombre}`);
            setError(false);
    
            // Cerrar el modal después de la actualización
            setmodalcausales(false);
        } catch (err) {
            console.error("Error al modificar la causal:", err);
    
            // Mostrar un mensaje de error en el helperText
            setHelperText("Ocurrió un error al modificar la causal.");
            setError(true);
        }
    };
  

    const handleChangeCausal = (e) => {
        console.log(e)
        setValue(e)
    }




    function retreiveCorreos() {
        correoService.getAll()
            .then(resp => {
                console.log(resp.data);
                setCorreos(resp.data);
            })
            .catch(err => {
                console.error(err);
            });
    }

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const limpiarFirma = () => {
        sigPad.clear();
    }

    const ingresar = () => {
        if (sigPad.isEmpty()) {
            alert("Ingrese Firma");
            return;
        }
        setLoading(true);
        var f = sigPad.toDataURL();
        var fr = f.split(',');

        const dataap = {
            tipo: "JEFERRLL",
            fecha: Date.now(),
            firma: fr[1],
            id_causal: causal.id
        }
        aprobadorService.ingresar(dataap)
            .then(a => {
                console.log(a);
            })
            .catch(err => {
                console.error(err);
            });

        /** Enviamos mail a Adm RRHH */
        var html = crearHtml(new Date().toString(), causal.id, persona);
        var crr = correos.filter(v => v.destino === "RRHH" & v.proyecto === persona.ctoDescripcion);
        var send = [];
        if (crr) {
            for (var i in crr) {
                send.push(crr[i].correo);
            }
        }
        const _data_mail = {
            nombre: "RRHH",
            //from_name: "Encuesta Salud Ecora S.A.",
            mensaje: html,//"Con fecha " + new Date().toString() + " se ha generado un desvinculación, para la cual se necesita completar a traves del siguiente link: http://ecoraapp.com/inicio/15740886-0 \n con Causal: " + state.causal,
            email: send//["plagues@ecora.cl", "mlillo@ecora.cl"]//persona.perCorreo
        }
        //Envío correo a RRHH
        emailService.sendMail(_data_mail)
            .then(response => {
                console.log(response);
                enqueueSnackbar('Correos enviados correctamente!', { variant: "success" });
                personaService.update(persona.id, { estado_desv: "En Proceso de RRHH" })
                    .then(resp => {
                        console.log(resp);
                        enqueueSnackbar("Se ha actualizado correctamente el estado de Desvinculación!", { variant: 'info' });
                    }).catch(err => {
                        console.error(err);
                        enqueueSnackbar('Ha ocurrido un error al cambiar el estado!', { variant: "error" });
                        causalService.update(causal.id, { estado: "anulado" })
                            .then(resp => {
                                console.log(resp.data);
                                enqueueSnackbar("Se anulo la causal!", { variant: "info" });
                            }).catch(err => {
                                console.error(err);
                                enqueueSnackbar("Ha ocurrido un error al actualizar la Causal!!", { variant: 'error' });
                            })

                    })
                setLoading(false);
                navigate("/salida");
            })
            .catch(e => {
                console.log(e);
                setLoading(false);
                enqueueSnackbar('Error al enviar correo!', { variant: "error" });
            });
    };

    function crearHtmlUsuario(fecha, causal, id_causal, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:#90c7fe;border:#a3a3a3 1px solid;'>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha generado una desvinculación, para la persona: ${persona.Rut + ' - ' + persona.perNombre1 + ' ' + persona.perApPaterno}</a> \n <p>con Causal: ${causal} </p>`;
        html = html + "</div>";
        return html;
    }

    function crearHtml(fecha, id_causal, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:whitesmoke;border:#a3a3a3 1px solid;'>";
        html = html + "<center><h3>Aviso de Desvinculación</h3></center><br/>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha generado una desvinculación, para la cual se necesita completar información a traves del siguiente link: </p> <a href="${baseurl}/finiquitopt2/${id_causal}">${persona.Rut + " - " + persona.perNombre1 + " " + persona.perApPaterno}</a> \n`;
        html = html + "</div>";
        return html;
    }

    function crearHtmlGG(fecha, id_causal, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:#90c7fe;border:#a3a3a3 1px solid;'>";
        html = html + "<center><h3>Aviso de Desvinculación</h3></center><br/>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha generado una desvinculación, la cual requiere de su revisión y aprobación, por favor revisar a traves del siguiente link: </p> <a href="${baseurl}/finiquitogergen/${id_causal}">${persona.Rut + " - " + persona.perNombre1 + " " + persona.perApPaterno}</a> \n`;
        html = html + "</div>";
        return html;
    }

    const handleClickOpen = () => {
        setmodalcausales(true);
    };

    const handleClickClose = () => {
        setOpen(false);
    };
    const handleClose = () => {
        setOpen(false);
        navigate("/desvincular");
    };


    //rechazar la causal 
    const rechazarDesv = () => {
        setRechazo(!rechazo);
    }

    //enviar motivo de rechazo de causal
    const enviarRechazo = async () => {
        console.log("Motivo rechazo", motivoRechazo);
        if (motivoRechazo === "") {
            alert("Ingrese un motivo de rechazo");
            return;
        }
        setLoading(true);
        try {
            let pers = await personaService.update(persona.id, { estado_desv: "Desvinculación rechazada por Gerencia" });
            if (pers.data) {
                //Enviamos Mail a RRHH que se rechazo por gerencia la desvinculacion
                var html = crearHtmlRechazo(new Date().toString(), causal.nombre, causal.id, persona);
                var crr = correos.filter(v => v.destino === "RRHH" & v.proyecto === persona.ctoDescripcion);
                //Traemos los proyectos
                const proy = await proyectoService.getAll();
                var proy_adc = proy.data.filter(v => v.nombre === persona.ctoDescripcion);
                console.log("Proy ADC", proy_adc);
                const user = await usuarioService.get(proy_adc[0].usuarioId);
                console.log("Usuario Rechazo", user.data);
                var send = [];
                /* if (crr) {
                    for (var i in crr) {
                        send.push(crr[i].correo);
                    }
                } */
                if (user) {
                    send.push(user.data.correo);
                }
                const _data_mail = {
                    nombre: "RRHH",
                    mensaje: html,
                    email: send
                }
                //Envío mail a RRHH indicando que Gerencia rechazo la desvinculacion
                let mail = emailService.sendMail(_data_mail);
                if (mail) {
                    enqueueSnackbar("Rechazo enviado correctamente!!", { variant: "success" });
                    setTimeout(() => {
                        navigate("/desvincular");
                    }, 2000);
                }
            }
        } catch (error) {
            console.log(error);
            enqueueSnackbar("Ocurrio un error al rechazar!!", { variant: "error" });
        }
        setLoading(false);
    }


    function crearHtmlRechazo(fecha, causal, id_causal, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:whitesmoke;border:#a3a3a3 1px solid;'>";
        html = html + "<center><h3>Aviso de Rechazo de Desvinculación</h3></center><br/>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha rechazado una desvinculación para la persona: ${persona.Rut + ' - ' + persona.perNombre1 + ' ' + persona.perApPaterno} con la causal: ${causal} </p> \n <p>con el siguiente motivo: ${motivoRechazo}</p>`;
        html = html + "</div>";
        return html;
    }

    /* COMENTADO HASTA NUEVO AVISO (FUNCION DE CORREO AL MODIFICAR CAUSALES )
//Modificar causal 
const ModificarCausal = () => {
setCausal(causal);
} */

    //enviar motivo de modificacion de causal 
    /*   const enviarModificacionCausal = async () => {
         console.log("Modificacion de Causal", MotivoModificarCausal);
         if (MotivoModificarCausal === "") {
             alert("Ingrese un motivo de modificacion de causal");
             return;
         }
         setLoading(true);
         try {
             let pers = await personaService.update(persona.id, { estado_desv: "En Jefe de RRLL" });
             if (pers.data) {
                 //Enviamos Mail a RRHH que se modifico la causal 
                 var html = crearHtmlModificacionCausal(new Date().toString(), causal.nombre, causal.id, persona);
                 var crr = correos.filter(v => v.destino === "RRHH" & v.proyecto === persona.ctoDescripcion);
                 //Traemos los proyectos
                 const proy = await proyectoService.getAll();
                 var proy_adc = proy.data.filter(v => v.nombre === persona.ctoDescripcion);
                 console.log("Proy ADC", proy_adc);
                 const user = await usuarioService.get(proy_adc[0].usuarioId);
                 console.log("Usuario Modificado", user.data);
                 var send = [];
                 /* if (crr) {
                     for (var i in crr) {
                         send.push(crr[i].correo);
                     }
                 } 
                 if (user) {
                     send.push(user.data.correo);
                 }
                 const _data_mail = {
                     nombre: "RRHH",
                     mensaje: html,
                     email: send
                 }
                 //Envío mail a RRHH indicando que Gerencia rechazo la desvinculacion
                 let mail = emailService.sendMail(_data_mail);
                 if (mail) {
                     enqueueSnackbar("Modificacion notificada correctamente!!", { variant: "success" });
                     setTimeout(() => {
                         navigate("/desvincular");
                     }, 2000);
                 }
             }
         } catch (error) {
             console.log(error);
             enqueueSnackbar("Ocurrio un error al Modificar!!", { variant: "error" });
         }
         setLoading(false);
     }
 
 
     function crearHtmlModificacionCausal(fecha, causal, id_causal, persona) {
         const currentURL = window.location.host;
         const protocol = window.location.protocol;
         const baseurl = protocol + "//" + currentURL;
         var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:whitesmoke;border:#a3a3a3 1px solid;'>";
         html = html + "<center><h3>Aviso de Modificacion de Causal</h3></center><br/>";
         html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha modificado la causal de una desvinculación para la persona: ${persona.Rut + ' - ' + persona.perNombre1 + ' ' + persona.perApPaterno} con la causal: ${causal} </p> \n <p>con el siguiente motivo: ${ModificarCausal}</p>`;
         html = html + "</div>";
         return html;
     }
     */
    return (
        <Container component="main" maxWidth="xs">
            {loading ? (
                <DotLoaderOverlay size={28} message="Cargando..." color="#4F8BFA" />
            ) : ""}
            <Card sx={{ maxWidth: 345 }}>
                <CardHeader
                    avatar={
                        <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
                            {persona ? persona.perNombre1.charAt(0).toUpperCase() : ""}
                        </Avatar>
                    }
                    action={
                        <IconButton aria-label="settings">
                            <MoreVertIcon />
                        </IconButton>
                    }
                    title={persona.perNombre1 + " " + persona.perApPaterno + " " + persona.perApMaterno}
                    subheader={persona.Rut}
                />
                <CardMedia
                    component="img"
                    height="194"
                    image="/logo512.png"
                    alt="Ecora S.A."
                />
                <CardContent>
                    <Typography variant="body2" color="text.secondary">
                        <p><strong>Causal:</strong> {causal.descripcion}</p>
                        <p><strong>Comentarios:</strong> {causal.comentario}</p>
                        <p><strong>Evaluación:</strong> {causal.evaluacion}</p>
                        <p><strong>Fecha Ingreso Desvinculación:</strong> {moment(causal.fecha_ingreso).format("DD-MM-YYYY")}</p>
                    </Typography>
                </CardContent>
                <CardActions disableSpacing>
                    <Typography variant='6' sx={{
                        fontStyle: "inherit",
                        fontWeight: "bold"
                    }}>
                        Datos Trabajador
                    </Typography>
                    {/* <IconButton aria-label="add to favorites">
                    <FavoriteIcon />
                </IconButton>
                <IconButton aria-label="share">
                    <ShareIcon />
                </IconButton> */}
                    <ExpandMore
                        expand={expanded}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                    >
                        <ExpandMoreIcon />
                    </ExpandMore>
                </CardActions>
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <CardContent>
                        {/* <Typography paragraph>Method:</Typography> */}
                        <Typography paragraph>
                            <p><strong>Unidad de Negocio:</strong> {persona.ctoDescripcion}</p>
                            <p><strong>Cargo:</strong> {persona.recDescripcion}</p>
                            <p><strong>Fecha de Contrato:</strong> {moment(persona.FechaContratoInicial).format("DD-MM-YYYY")}</p>
                        </Typography>
                        {persona.documento && persona.documento.length > 0 ? (
                            <table>
                                <thead>
                                    <th>Nombre Documento</th>
                                    <th>Archivo</th>
                                </thead>
                                <tbody>
                                    {persona.documento.map(doc => (
                                        <tr>
                                            <td>{doc.nombre}</td>
                                            <td><IconButton onClick={() => window.open(doc.ruta, "_blank")}><PictureAsPdfIcon color="success" /></IconButton></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : ""}
                    </CardContent>
                </Collapse>
            </Card>
            <Typography variant='h6' sx={{
                marginTop: 3
            }}>
                Ingresar Firma:
            </Typography>
            <Box sx={{
                marginTop: 1,
                justifyContent: "center",
                alignItems: "center",
                display: "flex"
            }}>
                <SignatureCanvas
                    canvasProps={{
                        className: "sginatureCanvas"
                    }}
                    ref={(ref) => { setSigPad(ref) }}
                />
            </Box>
            <Box sx={{
                margin: 1,
                justifyContent: "end",
                alignItems: "end",
                display: "flex"
            }}>
                <Button variant='outlined' color='info' onClick={limpiarFirma}>Limpiar Firma</Button>
            </Box>
            <Box sx={{
                margin: 3,
                justifyContent: "end",
                alignItems: "end",
                display: "flex"
            }}>
                <Stack direction="row" spacing={4}>
                    <Button variant='contained' onClick={ingresar}>APROBAR</Button>
                    <Button variant='contained' color='secondary' onClick={rechazarDesv}>RECHAZAR</Button>
                    <Button variant='contained' onClick={handleClickOpen}>MODIFICAR CAUSAL</Button>
                </Stack>
            </Box>
            <Modal
                open={modalcausales}
                onClose={handleClickClose}
                center
            >
                <form onSubmit={handleSubmitModificarCausal}>
                    <FormControl sx={{ m: 3 }} error={error} variant="standard">
                        <FormLabel id="demo-error-radios">Debe de escoger una nueva causal.</FormLabel>
                        <RadioGroup
                            aria-labelledby="demo-error-radios"
                            name="Mcausales"
                            value={value}
                            onChange={handleRadioChange}
                        >
                            {causalmaestro.map(mc => (
                                <FormControlLabel value={mc.id} control={<Radio />} label={mc.nombre + " " + mc.descripcion} onChange={(e) => handleChangeCausal(e.target.value)} />
                            ))}

                        </RadioGroup>
                        <FormHelperText>{helperText}</FormHelperText>
                        <Button sx={{ mt: 1, mr: 1 }} onClick={handleSubmitModificarCausal} type="submit" variant="outlined">
                            Modificar Causal
                        </Button>
                    </FormControl>
                </form>
            </Modal>

            {rechazo ? (
                <FormControl fullWidth>
                    <FormLabel>Motivo del Rechazo:</FormLabel>
                    <TextField
                        placeholder="Ingrese motivo aqui..."
                        multiline
                        fullWidth
                        minRows={3}
                        autoFocus
                        onChange={(e) => setMotivoRechazo(e.target.value)}
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 'var(--Textarea-paddingBlock)',
                            pt: 'var(--Textarea-paddingBlock)',
                            borderTop: '1px solid',
                            borderColor: 'divider',
                            flex: 'auto',
                        }}
                    >
                        <Button variant='contained' onClick={enviarRechazo} sx={{ ml: 'auto', mt: 1, mb: 1 }}>Enviar</Button>
                    </Box>
                </FormControl>
            ) : ""}
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Trabajador en Proceso de Desvinculación"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        El trabajador ya se encuentra en proceso de desvinculación, por favor comuniquese con el
                        departamento de RRHH.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Aceptar</Button>
                    {/* <Button onClick={handleClose} autoFocus>
                        Agree
                    </Button> */}
                </DialogActions>
            </Dialog>
        </Container>
    )
}

export default function FiniquitoRRLLStack() {
    return (
        <SnackbarProvider maxSnack={3}>
            <FiniquitoRRLL />
        </SnackbarProvider>
    )
}